(function () {
  function equalizeSizes(root) {
    if (!root) return;
    root.querySelectorAll('[data-ssc-sizes]').forEach((box) => {
      const pills = [...box.querySelectorAll('.ssc-size')];
      if (!pills.length) return;
      const probe = document.createElement('div');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;display:flex;';
      pills.forEach((pill) => {
        const clone = pill.cloneNode(true);
        clone.style.width = 'max-content';
        clone.style.whiteSpace = 'nowrap';
        probe.appendChild(clone);
      });
      document.body.appendChild(probe);
      const widest = Math.ceil(Math.max(...[...probe.children].map((node) => node.offsetWidth)));
      probe.remove();
      if (widest > 20) pills.forEach((pill) => { pill.style.width = widest + 'px'; });
    });
  }

  function tidyQuickAdd(root) {
    root.querySelectorAll('.product-header').forEach((node) => node.remove());
    if (root.querySelector('.ssc-qa__dock')) return;
    const form = root.querySelector('product-form-component');
    if (!form) return;
    const dock = document.createElement('div');
    dock.className = 'ssc-qa__dock';
    const details = root.querySelector('.ssc-qa__details');
    form.before(dock);
    dock.append(form);
    if (details) dock.append(details);
  }

  // Quick add (prompt 128): the modal's content is swapped on every open (quick-add.js morphs the new product in), so
  // the listeners are bound once on the modal and every node, and the picked size, is looked up at the moment of use.
  function bootQuickAdd(modal) {
    const find = (sel) => modal.querySelector(sel);
    const watched = new WeakSet();

    function showError(message) {
      const error = find('[data-ssc-qa-error]');
      if (!error) return;
      error.hidden = !message;
      error.textContent = message || '';
    }

    // Per open: tidy, equal size pills, ship-by dates, and the status region (each region observed once).
    function setup() {
      if (!find('.ssc-qa__add')) return;
      tidyQuickAdd(modal);
      equalizeSizes(modal);
      if (window.SSCShipBy) window.SSCShipBy.fill(modal);
      const add = find('[data-ssc-add]');
      if (!add || watched.has(add)) return;
      watched.add(add);
      const live = find('[ref="liveRegion"], [data-ssc-qa-error]');
      const region = find('[role="status"]');
      if (region && !watched.has(region)) {
        watched.add(region);
        new MutationObserver(() => {
          const message = region.textContent.trim();
          if (message) showError(message);
        }).observe(region, { childList: true, subtree: true, characterData: true });
      }
      if (live) live.hidden = live !== find('[data-ssc-qa-error]');
    }

    function pickSize(button) {
      modal.querySelectorAll('.ssc-size').forEach((node) => {
        const on = node === button;
        node.classList.toggle('is-selected', on);
        node.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      const variantInput = find('[data-ssc-variant]');
      if (variantInput) {
        variantInput.disabled = false;
        variantInput.value = button.dataset.id || '';
      }
      const sold = button.dataset.available !== 'true';
      const addWord = find('[data-ssc-add-word]');
      if (addWord) addWord.textContent = sold ? 'SOLD OUT' : 'ADD TO CART';
      const priceNode = find('[data-ssc-price]');
      if (priceNode) {
        priceNode.hidden = sold;
        priceNode.textContent = button.dataset.price || '';
      }
      const addButton = find('[data-ssc-add]');
      if (addButton) {
        addButton.classList.toggle('ssc-add--sold', sold);
        addButton.disabled = sold;
      }
      const isReady = Number(button.dataset.qty) > 0;
      const box = find('[data-ssc-mto]');
      if (box) {
        box.classList.add('is-on');
        box.hidden = false;
        const ready = box.querySelector('[data-ssc-mto-ready]');
        const make = box.querySelector('[data-ssc-mto-make]');
        const sub = box.querySelector('[data-ssc-mto-sub]');
        if (ready) ready.hidden = !isReady;
        if (make) make.hidden = isReady;
        if (sub) sub.hidden = isReady;
      }
      const narr = find('[data-ssc-qa-narr]');
      if (narr) {
        const ready = narr.querySelector('[data-ssc-qa-narr-ready]');
        const make = narr.querySelector('[data-ssc-qa-narr-make]');
        if (ready) ready.hidden = !isReady;
        if (make) make.hidden = isReady;
      }
      const pick = find('[data-ssc-qa-pick]');
      if (pick) pick.hidden = true;
      showError('');
    }

    modal.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const size = target.closest('.ssc-size');
      if (size && modal.contains(size)) {
        pickSize(size);
        return;
      }
      const thumb = target.closest('[data-ssc-qa-thumb]');
      if (thumb && modal.contains(thumb)) {
        const photo = find('.ssc-qa__photo');
        if (photo) {
          photo.srcset = thumb.dataset.srcset || '';
          photo.src = thumb.dataset.src || photo.src;
        }
        modal.querySelectorAll('[data-ssc-qa-thumb]').forEach((node) => {
          const on = node === thumb;
          node.classList.toggle('is-on', on);
          node.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        return;
      }
      const step = target.closest('[data-ssc-qty]');
      if (step && modal.contains(step)) {
        const qtyInput = find('[data-ssc-qty-input]');
        if (qtyInput) qtyInput.value = String(Math.max(1, Number(qtyInput.value || 1) + Number(step.dataset.sscQty)));
      }
    });

    // Size required: the picked size is the current content's selected pill (a new product arrives with none).
    function needSize(event) {
      if (event.type === 'click' && !(event.target instanceof Element && event.target.closest('[data-ssc-add]'))) return;
      const sizes = find('[data-ssc-sizes]');
      if (!sizes || !find('.ssc-size') || find('.ssc-size.is-selected')) return;
      event.preventDefault();
      event.stopPropagation();
      const pick = find('[data-ssc-qa-pick]');
      if (pick) pick.hidden = false;
      sizes.classList.remove('ssc-shake');
      sizes.offsetWidth;
      sizes.classList.add('ssc-shake');
      sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    modal.addEventListener('click', needSize, true);
    modal.addEventListener('submit', needSize, true);

    new MutationObserver(setup).observe(modal, { childList: true, subtree: true });
    setup();
  }

  const modal = document.getElementById('quick-add-modal-content');
  if (modal) bootQuickAdd(modal);

  // Add refused by Shopify (prompt 129: sold out since the page loaded, more than the stock, no size): product-form.js
  // only writes the reason into a ref="addToCartTextError" node, which the quick add and product page don't have, so
  // the tap looked dead. Show Shopify's reason under the button instead (quick add: its error line; product page: one
  // line made on first use). It clears on the next size tap or successful add.
  document.addEventListener('shopify:cart:error', (event) => {
    const form = event.target instanceof Element ? event.target : null;
    const scope = form && form.closest('#quick-add-modal-content, [data-ssc-pdp]');
    if (!scope) return;
    const message = (event.detail && event.detail.description) || event.error || 'Couldn’t add this. Try another size.';
    let line = scope.querySelector('[data-ssc-qa-error], [data-ssc-add-error]');
    if (!line) {
      const buy = scope.querySelector('.ssc-buy');
      if (!buy) return;
      line = document.createElement('p');
      line.className = 'ssc-qa__error';
      line.setAttribute('role', 'alert');
      line.dataset.sscAddError = '';
      buy.after(line);
    }
    line.textContent = message;
    line.hidden = false;
  });
  const clearAddError = () => document.querySelectorAll('[data-ssc-add-error]').forEach((line) => { line.hidden = true; });
  document.addEventListener('shopify:cart:lines-update', clearAddError);
  document.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('[data-ssc-pdp] .ssc-size')) clearAddError();
  });

  const root = document.querySelector('[data-ssc-pdp]');
  if (!root) return;

  const track = root.querySelector('[data-ssc-track]');
  const count = root.querySelector('[data-ssc-count]');
  const thumbs = [...root.querySelectorAll('[data-ssc-thumb]')];
  const slides = [...root.querySelectorAll('[data-ssc-zoom]')];
  const sizes = root.querySelector('[data-ssc-sizes]');
  const variantInput = root.querySelector('[data-ssc-variant]');
  const addButton = root.querySelector('[data-ssc-add]');
  const addWord = root.querySelector('[data-ssc-add-word]');
  const priceNodes = root.querySelectorAll('[data-ssc-price]');
  const mainPrice = root.querySelector('[data-ssc-main-price]');
  const compareNode = root.querySelector('[data-ssc-compare]');
  const sticky = document.querySelector('[data-ssc-sticky]');
  const stickySize = document.querySelector('[data-ssc-sticky-size]');
  const stickyWord = document.querySelector('[data-ssc-sticky-word]');
  const stickyPrice = document.querySelector('[data-ssc-sticky-price]');
  const stickyAdd = document.querySelector('[data-ssc-sticky-add]');
  const qtyInput = root.querySelector('[data-ssc-qty-input]');
  const mto = root.querySelector('[data-ssc-mto]');

  // Long product names on phones (prompt 119): shrink the title just enough to stay on one line next to the thumbnails
  // (not under 26px). If it still doesn't fit, the thumbnails move under the gallery when that layout is shorter.
  const fitTitleNode = root.querySelector('.ssc-pdp__title');
  const fitThumbs = root.querySelector('[data-ssc-thumbs]');
  const fitThumbsHome = fitThumbs ? fitThumbs.parentNode : null;
  const fitGallery = root.querySelector('[data-ssc-gallery]');
  const fitPhone = window.matchMedia('(max-width: 749px)');
  function fitTitle() {
    if (!fitTitleNode) return;
    fitTitleNode.style.fontSize = '';
    fitTitleNode.style.whiteSpace = '';
    if (fitThumbs && fitThumbs.parentNode !== fitThumbsHome) {
      fitThumbsHome.append(fitThumbs);
      fitThumbs.classList.remove('is-under');
    }
    if (!fitPhone.matches) return;
    const range = document.createRange();
    range.selectNodeContents(fitTitleNode);
    const shrink = () => {
      fitTitleNode.style.whiteSpace = 'nowrap';
      const cs = getComputedStyle(fitTitleNode);
      // The row's width, not the title's: a nowrap title grows past the row.
      const room = fitTitleNode.parentNode.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      let size = parseFloat(cs.fontSize);
      while (size > 26 && range.getBoundingClientRect().width > room) {
        size -= 1;
        fitTitleNode.style.fontSize = size + 'px';
      }
      const fits = range.getBoundingClientRect().width <= room;
      fitTitleNode.style.whiteSpace = '';
      return fits;
    };
    if (shrink() || !fitThumbs || !fitGallery) return;
    // Still wraps at 26px: try the thumbnails under the gallery with the name at full width, and keep whichever of the two
    // layouts is shorter (the thumbnail row under the gallery costs ~58px).
    const beside = fitTitleNode.style.fontSize;
    const besideH = fitThumbsHome.getBoundingClientRect().height;
    fitTitleNode.style.fontSize = '';
    fitThumbs.classList.add('is-under');
    fitGallery.after(fitThumbs);
    shrink();
    const underH = fitThumbsHome.getBoundingClientRect().height + fitThumbs.getBoundingClientRect().height + 10;
    if (underH < besideH) return;
    fitThumbsHome.append(fitThumbs);
    fitThumbs.classList.remove('is-under');
    fitTitleNode.style.fontSize = beside;
  }
  fitTitle();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitTitle);
  fitPhone.addEventListener?.('change', fitTitle);
  let selected = null;

  function setCount(index) {
    if (!slides.length) return;
    if (count) count.textContent = (index + 1) + ' / ' + slides.length;
    thumbs.forEach((thumb, i) => thumb.classList.toggle('is-selected', i === index));
    slides.forEach((slide, i) => slide.classList.toggle('is-selected', i === index));
  }

  if (track) {
    track.addEventListener('scroll', () => {
      let index = 0;
      let best = Infinity;
      slides.forEach((slide, i) => {
        const delta = Math.abs(slide.offsetLeft - track.scrollLeft);
        if (delta < best) {
          best = delta;
          index = i;
        }
      });
      setCount(index);
    }, { passive: true });
  }

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const index = Number(thumb.dataset.sscThumb);
      const slide = slides[index];
      if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      setCount(index);
    });
  });

  slides.forEach((slide) => {
    slide.addEventListener('click', (event) => {
      const dialog = root.querySelector('zoom-dialog');
      if (dialog && typeof dialog.open === 'function') {
        dialog.open(Number(slide.dataset.sscZoom), event);
      }
    });
  });

  function moneyTargets(price, compare) {
    if (mainPrice) mainPrice.textContent = price || '';
    priceNodes.forEach((node) => { node.textContent = price || ''; });
    if (stickyPrice) stickyPrice.textContent = price || '';
    if (compareNode) {
      compareNode.hidden = !compare;
      compareNode.textContent = compare || '';
    }
  }

  function setSoldOut(sold) {
    addButton.classList.toggle('ssc-add--sold', sold);
    addButton.disabled = sold;
    if (addWord) addWord.textContent = sold ? 'SOLD OUT' : 'ADD TO CART';
    priceNodes.forEach((node) => { node.hidden = sold; });
    if (stickyAdd) stickyAdd.classList.toggle('ssc-add--sold', sold);
    if (stickyWord) stickyWord.textContent = sold ? 'SOLD OUT' : 'ADD TO CART';
    if (stickyPrice) stickyPrice.hidden = sold;
  }

  function shortSize(label) {
    const map = { 'X-Small': 'XS', Small: 'S', Medium: 'M', Large: 'L', 'X-Large': 'XL', '2X-Large': '2XL', '3X-Large': '3XL' };
    return map[label] || label;
  }

  function scopeOf(node) {
    return node.closest('[data-ssc-pdp], #quick-add-modal-content') || root;
  }

  function setDelivery(qty, scope) {
    const box = (scope || root).querySelector('[data-ssc-mto]');
    if (!box) return;
    box.hidden = false;
    const ready = box.querySelector('[data-ssc-mto-ready]');
    const make = box.querySelector('[data-ssc-mto-make]');
    const sub = box.querySelector('[data-ssc-mto-sub]');
    const isReady = Number(qty) > 0;
    if (ready) ready.hidden = !isReady;
    if (make) make.hidden = isReady;
    if (sub) sub.hidden = isReady;
    // Ship line (prompt 118): the before-a-size line goes, and its ⓘ marks the picked size's row.
    const none = box.querySelector('[data-ssc-ship-none]');
    if (none) none.hidden = true;
    box.querySelector('[data-ssc-info]')?.setAttribute('data-ssc-info-here', isReady ? 'in' : 'mto');
    const strip = (scope || root).querySelector('[data-ssc-strip]');
    if (strip) strip.hidden = isReady;
  }

  function selectSize(button) {
    const scope = scopeOf(button);
    if (scope === root) selected = button;
    scope.querySelectorAll('.ssc-size').forEach((node) => {
      const on = node === button;
      node.classList.toggle('is-selected', on);
      node.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    const input = scope.querySelector('[data-ssc-variant]');
    if (input) {
      input.disabled = false;
      input.value = button.dataset.id;
    }
    const main = scope.querySelector('[data-ssc-main-price]');
    const price = scope.querySelector('[data-ssc-price]');
    const compare = scope.querySelector('[data-ssc-compare]');
    const word = scope.querySelector('[data-ssc-add-word]');
    const add = scope.querySelector('[data-ssc-add]');
    const sold = button.dataset.available !== 'true';
    if (main) main.textContent = button.dataset.price || '';
    if (price) {
      price.hidden = sold;
      price.textContent = button.dataset.price || '';
    }
    if (compare) {
      compare.hidden = !button.dataset.compare;
      compare.textContent = button.dataset.compare || '';
    }
    if (word) word.textContent = sold ? 'SOLD OUT' : 'ADD TO CART';
    if (add) {
      add.classList.toggle('ssc-add--sold', sold);
      add.disabled = sold;
    }
    setDelivery(button.dataset.qty, scope);
    if (scope === root) {
      if (stickySize) stickySize.textContent = shortSize(button.dataset.label || '') + ' · ';
      if (stickyWord) stickyWord.textContent = sold ? 'SOLD OUT' : 'ADD TO CART';
      if (stickyPrice) stickyPrice.textContent = button.dataset.price || '';
      stickyAdd?.classList.toggle('ssc-add--sold', sold);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', button.dataset.id);
      history.replaceState({}, '', url);
      syncExpress();
    }
  }

  // Small express buttons under Add to cart (sections/ssc-product.liquid): usable only once a size that can be bought is
  // picked (or the product has a single variant), the same moment Add to cart would really add.
  const express = root.querySelector('[data-ssc-express]');
  function syncExpress() {
    if (!express) return;
    const needsSize = !!root.querySelector('.ssc-size');
    const ready = (!needsSize || !!selected) && variantInput && !variantInput.disabled && !!variantInput.value && !addButton.disabled;
    express.classList.toggle('is-locked', !ready);
    express.querySelector('[data-ssc-express-btns]')?.toggleAttribute('inert', !ready);
  }
  express?.querySelector('[data-ssc-express-guard]')?.addEventListener('click', () => {
    if (root.querySelector('.ssc-size') && !selected) shakeSizes();
  });
  // Shopify decides whether its button shows (it sets display:none on .shopify-payment-button otherwise, live theme too):
  // the block, with its "or buy now with" line, appears only once a real button has drawn.
  if (express) {
    const checkReady = () => {
      const pb = express.querySelector('.shopify-payment-button');
      const shown = !!pb && pb.style.display !== 'none' && !express.querySelector('.shopify-payment-button__skeleton');
      express.classList.toggle('is-ready', shown);
    };
    new MutationObserver(checkReady).observe(express, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'class'] });
    checkReady();
  }

  function shakeSizes() {
    if (!sizes) return;
    sizes.classList.remove('ssc-shake');
    sizes.offsetWidth;
    sizes.classList.add('ssc-shake');
    sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('.ssc-size') : null;
    if (!button || !button.closest('[data-ssc-pdp], #quick-add-modal-content')) return;
    selectSize(button);
  });

  const preset = new URL(window.location.href).searchParams.get('variant');
  const presetButton = preset && root.querySelector('.ssc-size[data-id="' + preset + '"]');
  if (presetButton) selectSize(presetButton);
  else if (root.dataset.sscSingle && variantInput) {
    variantInput.disabled = false;
    variantInput.value = root.dataset.sscSingle;
    setSoldOut(root.dataset.sscSingleAvailable !== 'true');
    if (mto) setDelivery(root.dataset.sscSingleQty);
  }
  syncExpress();

  root.querySelectorAll('[data-ssc-qty]').forEach((button) => {
    button.addEventListener('click', () => {
      const next = Math.max(1, Number(qtyInput.value || 1) + Number(button.dataset.sscQty));
      qtyInput.value = String(next);
    });
  });

  function guardAdd(event) {
    if (root.querySelector('.ssc-size') && !selected) {
      event.preventDefault();
      event.stopPropagation();
      shakeSizes();
    }
  }
  addButton.addEventListener('click', guardAdd);
  root.querySelector('form')?.addEventListener('submit', guardAdd, true);
  // Sticky bar tap (prompt 118): no size yet = scroll to the sizes and pulse them; otherwise the real Add to cart button,
  // so one-per, VIP, made-to-order and the cart all behave exactly as there.
  stickyAdd?.addEventListener('click', () => {
    if (root.querySelector('.ssc-size') && !selected) {
      if (sizes) {
        sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
        sizes.classList.remove('ssc-pulse');
        sizes.offsetWidth;
        sizes.classList.add('ssc-pulse');
      }
      return;
    }
    if (addButton.disabled) return;
    addButton.click();
  });

  // Sticky bar (prompt 118): phones under 750px, while the main Add to cart is off screen and the footer isn't. It tells
  // assets/ssc-manga.js (ssc:sticky) so the free-item bar steps aside; the chat bubble already rises above .ssc-sticky.
  if (addButton && sticky && 'IntersectionObserver' in window) {
    const footer = document.querySelector('.ssc-footer');
    const phone = window.matchMedia('(max-width: 749px)');
    let addSeen = true;
    let addClear = true;
    let footerSeen = false;
    const setSticky = () => {
      const on = phone.matches && !addSeen && !footerSeen;
      // is-guard: the main button is on screen but in the bottom 70px, where the free-item bar would cover it.
      const guard = phone.matches && addSeen && !addClear;
      if (sticky.classList.contains('is-on') === on && sticky.classList.contains('is-guard') === guard) return;
      sticky.classList.toggle('is-on', on);
      sticky.classList.toggle('is-guard', guard);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      sticky.inert = !on;
      document.dispatchEvent(new CustomEvent('ssc:sticky', { detail: { on, guard } }));
    };
    const watch = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === footer) footerSeen = entry.isIntersecting;
        else addSeen = entry.isIntersecting;
      });
      setSticky();
    });
    watch.observe(addButton);
    if (footer) watch.observe(footer);
    new IntersectionObserver((entries) => {
      addClear = entries[entries.length - 1].intersectionRatio >= 0.99;
      setSticky();
    }, { rootMargin: '0px 0px -70px 0px', threshold: [0, 0.99] }).observe(addButton);
    phone.addEventListener?.('change', setSticky);
  }

  // "See photos" next to the stars (prompt 118): smooth scroll to the customer photos strip.
  root.querySelector('[data-ssc-see-photos]')?.addEventListener('click', (event) => {
    const strip = document.getElementById('ssc-photos');
    if (!strip) return;
    event.preventDefault();
    strip.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  const recentMount = document.querySelector('[data-ssc-recent]');
  const handle = root.dataset.productHandle;
  if (recentMount) {
    let stored = [];
    try { stored = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]'); } catch (error) { stored = []; }
    const previous = stored.filter((item) => item && item.handle && item.handle !== handle).slice(0, 8);
    if (previous.length) {
      recentMount.hidden = false;
      const trackNode = recentMount.querySelector('[data-ssc-recent-track]');
      previous.forEach((item) => {
        const price = Number(item.price || 0) / 100;
        const dollars = Number.isInteger(price) ? '$' + price : '$' + price.toFixed(2);
        const image = item.featured_image || (item.images && item.images[0]) || '';
        const card = document.createElement('a');
        card.className = 'ssc-recent__card';
        card.href = item.url || ('/products/' + item.handle);
        if (image) {
          const img = document.createElement('img');
          img.src = image;
          img.alt = '';
          card.appendChild(img);
        }
        if (item.type) {
          const type = document.createElement('p');
          type.className = 'ssc-recent__type';
          type.textContent = item.type;
          card.appendChild(type);
        }
        const name = document.createElement('p');
        name.className = 'ssc-recent__name';
        name.textContent = item.title || '';
        card.appendChild(name);
        const priceLine = document.createElement('p');
        priceLine.className = 'ssc-recent__name';
        priceLine.textContent = dollars;
        card.appendChild(priceLine);
        const itemWrap = document.createElement('div');
        itemWrap.className = 'ssc-recent__item';
        itemWrap.appendChild(card);
        trackNode.appendChild(itemWrap);
      });
    }
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'products/' + handle + '.js')
      .then((response) => response.json())
      .then((data) => {
        const next = [data].concat(stored.filter((item) => item && item.handle !== handle)).slice(0, 12);
        localStorage.setItem('recentlyViewedProducts', JSON.stringify(next));
      })
      .catch(() => {});
  }
})();
